// extracted by mini-css-extract-plugin
export var error = "ResetPasswordConfirm-module--error--E-uYt";
export var welcomeContent = "ResetPasswordConfirm-module--welcomeContent--syVTi";